import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

document.title = "Vodafone | Armon Müşteri Analiz Formu";
ReactDOM.render(<App />, document.getElementById("root"));
